import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { brokerApi } from "@/hooks/useBrokerApi";

const METRIC_CARDS = [
  { key: "drivers_connected", label: "Drivers Connected" },
  { key: "drivers_available", label: "Drivers Available" },
  { key: "drivers_on_assignment", label: "Drivers On Assignment" },
  { key: "invitations_pending", label: "Invitations Pending" },
  { key: "loads_needing_drivers", label: "Loads Needing Drivers" },
  { key: "offers_sent", label: "Offers Sent" },
  { key: "carrier_authorization_pending", label: "Carrier Authorization Pending" },
  { key: "ready_for_pickup", label: "Ready for Pickup" },
  { key: "in_transit", label: "In Transit" },
  { key: "delivered", label: "Delivered" },
  { key: "unbilled_services", label: "Unbilled Services" },
  { key: "open_invoices", label: "Open Invoices" },
  { key: "action_required", label: "Action Required" },
];

export const BrokerDashboardTab = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    brokerApi.get("/dashboard").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  if (!data) return <div className="flex justify-center py-16"><Loader2 size={22} className="animate-spin text-rr-orange" /></div>;

  return (
    <div data-testid="broker-dashboard-tab">
      <h2 className="font-heading text-xl font-bold text-rr-navy mb-5">My Driver Network</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {METRIC_CARDS.map((m) => (
          <div key={m.key} data-testid={`broker-dashboard-metric-${m.key}`} className="bg-white border border-rr-line rounded-xl p-4">
            <p className="text-2xl font-heading font-extrabold text-rr-navy">{data[m.key] ?? 0}</p>
            <p className="text-xs text-rr-muted font-semibold mt-1">{m.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
